query gerentesSelect {
    data: gerentes {
        value: codigo
        label: nome
    }
}